<template>
  <b-form @submit="salvar" class="row p-3">
    <input-select
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Tema"
      class="col-12"
      :options="options.temas"
      v-model="form.descricaoTecnica.temaSelecionado.temaId"
      ref="form-tema"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="200"
      label="Outro tema (Máximo 200 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.temaSelecionado.descricaoPersonalizada"
      placeholder="Máximo 200 caracteres"
      v-if="
        (form.descricaoTecnica.temaSelecionado.temaId && options.temas.length
          ? options.temas.find(
              (el) => el.value == form.descricaoTecnica.temaSelecionado.temaId
            ).text
          : '') == 'Outros'
      "
      ref="form-outroTema"
      :required="!TelaProponente"
    />

    <template>
      <div
        v-for="(subtema, i) in form.descricaoTecnica.subtemasSelecionados"
        class="col-12"
        :key="subtema.subtemaId"
      >
        <div class="row">
          <input-select
            :disabled="TelaProponente || TelaProponenteCooperada"
            class="col-12"
            :label="`Subtema ${i + 1}`"
            :options="options.subtemas"
            v-model="subtema.subtemaId"
            ref="form-subtema"
            :required="!TelaProponente"
          >
            <template #label>
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  {{ `Subtema ${i + 1}` }}
                </div>
                <b-button
                  variant="outline-danger"
                  pill
                  size="sm"
                  class="ml-2"
                  @click="removeSubtema(subtema)"
                  v-if="
                    !TelaProponente &&
                    form.descricaoTecnica.subtemasSelecionados.length > 1
                  "
                >
                  <i class="fa-solid fa-trash mr-2"></i>
                  Remover subtema
                </b-button>
              </div>
            </template>
          </input-select>
          <input-textarea
            :disabled="TelaProponente || TelaProponenteCooperada"
            :max-length="200"
            label="Outro subtema (Máximo 200 caracteres)"
            class="col-12"
            v-model="subtema.descricaoPersonalizada"
            placeholder="Máximo 200 caracteres"
            v-if="
              (subtema.subtemaId && options.subtemas.length
                ? options.subtemas.find((el) => el.value == subtema.subtemaId)
                    .text
                : ''
              ).includes('Outro')
            "
            ref="form-outroSubtema"
            :required="!TelaProponente"
          />
        </div>
      </div>
    </template>
    <div class="col-12 mb-4" v-if="!TelaProponente && !TelaProponenteCooperada">
      <b-button
        variant="info"
        size="sm"
        @click="addSubtema()"
        v-if="form.descricaoTecnica.subtemasSelecionados.length < 5"
      >
        <b-icon icon="plus-circle-fill" class="mr-2" />
        Adicionar subtema
      </b-button>
    </div>

    <input-select
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Segmento"
      class="col-12 col-md-4"
      :options="options.segmentos"
      v-model="form.descricaoTecnica.segmento"
      ref="form-segmento"
      :required="!TelaProponente"
    />
    <input-select
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Fase de inovação"
      class="col-12 col-md-4"
      :options="options.fases"
      v-model="form.descricaoTecnica.faseDeInovacao"
      ref="form-fase"
      :required="false"
    />
    <input-select
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="TRL - Grau de maturidade tecnológica"
      class="col-12 col-md-4"
      :options="trlOptions"
      v-model="form.descricaoTecnica.trl"
      ref="form-trl"
      :required="!TelaProponente"
    />
    <input-select
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Tipo de produto"
      class="col-12 col-md-4"
      :options="options.tipoProdutos"
      v-model="form.descricaoTecnica.tipoProduto"
      ref="form-tipoProduto"
      :required="!TelaProponente"
    />

    <input-text
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Titulo (Máximo 200 caracteres)"
      :max-length="200"
      placeholder="Máximo 200 caracteres"
      class="col-12 col-md-6"
      v-model="form.descricaoTecnica.titulo"
      ref="form-titulo"
      :required="!TelaProponente"
    />
    <input-text
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Apelido"
      class="col-12 col-md-6"
      v-model="form.descricaoTecnica.apelido"
      ref="form-apelido"
      :required="!TelaProponente"
    />
    <input-text
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max="48"
      :min="1"
      label="Duração(em meses)"
      class="col-12 col-md-6"
      v-model="form.descricaoTecnica.duracao"
      type="number"
      ref="form-duracao"
      :required="!TelaProponente"
    />
    <input-money
      :disabled="TelaProponente || TelaProponenteCooperada"
      label="Valor estimado R$"
      class="col-12 col-md-6"
      v-model="form.descricaoTecnica.valorEstimado"
      ref="form-valor"
      :required="!TelaProponente"
    />

    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="300"
      label="Descrição do produto (Máximo 300 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.descricaoProduto"
      placeholder="Máximo 300 caracteres"
      ref="form-descricao"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="1000"
      label="Motivação (Máximo 1000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.motivacao"
      placeholder="Máximo 1000 caracteres"
      ref="form-motivacao"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="2000"
      label="Originalidade (Máximo 2000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.originalidade"
      placeholder="Máximo 2000 caracteres"
      ref="form-originalidade"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="1000"
      label="Aplicabilidade (Máximo 1000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.aplicabilidade"
      placeholder="Máximo 1000 caracteres"
      ref="form-aplicabilidade"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="1000"
      label="Relevância (Máximo 1000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.relevancia"
      placeholder="Máximo 1000 caracteres"
      ref="form-relevancia"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="1000"
      label="Razoabilidade dos custos (Máximo 1000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.razoabilidadeCustos"
      placeholder="Máximo 1000 caracteres"
      ref="form-razoabilidade"
      :required="!TelaProponente"
    />
    <input-textarea
      :disabled="TelaProponente || TelaProponenteCooperada"
      :max-length="1000"
      label="Pesquisas correlatadas (Máximo 1000 caracteres)"
      class="col-12"
      v-model="form.descricaoTecnica.pesquisasCorrelatas"
      placeholder="Máximo 1000 caracteres"
      ref="form-pesquisas"
      :required="!TelaProponente"
    />

    <input-textarea
      :v-if="propostaId"
      :disabled="!TelaProponente && !TelaProponenteCooperada"
      label="Observação proponente"
      class="col-12"
      v-model="form.descricaoTecnica.observacao"
      ref="form-observacao"
      :required="TelaProponente"
    />
    <div v-if="!TelaProponente && !TelaProponenteCooperada" class="col-12 mb-2">
      <upload
        tituloArquivo="Arrastar Arquivo"
        @upload="(file, nomeArquivo) => uploadFunction(file, nomeArquivo)"
        selecioneArquivo="Selecionar Arquivo"
        type=".*"
      />
    </div>

    <template>
      <div
        v-for="(arquivo, i) in form.descricaoTecnica.arquivos"
        class="col-12"
        :key="arquivo.nome"
      >
        <div
          class="lista-arquivos d-flex"
          :class="`${i > 0 ? 'lista-arquivos__no_top' : ''}`"
        >
          <b-button
            v-if="!TelaProponente && !TelaProponenteCooperada"
            variant="danger"
            @click="removerArquivo(arquivo)"
            class="m-2"
            size="sm"
          >
            <b-icon icon="trash" class="mr-2" />
            Remover arquivo
          </b-button>
          <b-button
            v-if="arquivo.id"
            variant="info"
            @click="baixar(propostaOriginalId, arquivo.id)"
            class="m-2"
            size="sm"
          >
            <i class="fas fa-cloud-download"></i>
          </b-button>
          <div
            style="border-left: 1px solid #e5e5e5"
            class="lista-arquivos__left d-flex pl-2 align-items-center"
          >
            {{ arquivo.nome }}
          </div>
        </div>
      </div>
    </template>

    <div
      class="col-12 d-flex mt-2"
      v-if="
        propostaId
          ? permissao('PropostaDescricaoTecnica').u
          : permissao('Proposta').c
      "
    >
      <b-button type="submit" variant="success" class="mr-2">
        <i class="fa-solid fa-check mr-2"></i>
        Salvar
      </b-button>
      <b-button
        variant="outline-danger"
        @click="excluir"
        class="mr-2"
        v-if="false && form.descricaoTecnica.id"
      >
        <i class="fa-solid fa-trash mr-2"></i>
        Excluir
      </b-button>
    </div>
  </b-form>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";

import { START_LOADING, STOP_LOADING } from "@/store/Store";

import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import InfosService from "@/common/services/infos/infos.service";
import PropostaService from "@/common/services/proposta/proposta.service";
import helpers from "@/common/utils/helpers";

import cloneDeep from "lodash/cloneDeep";

const TRL_POR_FASE_INOVACAO = {
  PesquisaBasica: [1, 2],
  PesquisaAplicada: [3, 4],
  DesenvolvimentoExperimental: [5, 6],
  CabecaDeSerie: [7],
  LotePioneiro: [8],
  InsercaoNoMercado: [9],
};

export default {
  name: "PropostaDetalhamentoTecnico",
  mixins: [FormMixin, AlertasMixin],
  emits: ["update"],
  props: {
    propostaId: {
      required: true,
    },
    propostaOriginalId: {
      required: true,
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
      default: "Proposta",
    },
  },
  components: {
    InputText,
    InputSelect,
    InputTextarea,
    InputMoney,
    Upload,
  },
  data: () => ({
    accordion: false,
    form: {
      empresaId: null,
      descricaoTecnica: {
        id: null,

        temaSelecionado: {
          temaId: null,
          descricaoPersonalizada: null,
        },
        subtemasSelecionados: [
          {
            subtemaId: null,
            descricaoPersonalizada: null,
          },
        ],

        segmento: null,
        faseDeInovacao: null,
        trl: null,
        tipoProduto: null,
        titulo: null,
        apelido: null,
        duracao: null,
        valorEstimado: null,
        descricaoProduto: null,
        motivacao: null,
        originalidade: null,
        aplicabilidade: null,
        relevancia: null,
        razoabilidadeCustos: null,
        pesquisasCorrelatas: null,
        arquivos: [],
        observacao: null,
      },
    },

    options: {
      temas: [],
      subtemas: [],
      segmentos: helpers.Segmento,
      fases: helpers.FaseInovacao,
      trls: helpers.TRL,
      tipoProdutos: helpers.TipoProduto,
    },
  }),
  methods: {
    uploadFunction: function (file, nomeArquivo) {
      let arquivo = {
        nome: nomeArquivo,
        extensao: nomeArquivo.split(".").pop(),
        arquivoBase64: file,
      };
      this.form.descricaoTecnica.arquivos.push(arquivo);
    },
    baixar: function (propostaId, arquivoId) {
      this.$store.dispatch(START_LOADING);

      PropostaService.baixarArquivoDescricaoTecnica(propostaId, arquivoId)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    removerArquivo: function (arquivo) {
      let index = this.form.descricaoTecnica.arquivos.indexOf(arquivo);
      this.form.descricaoTecnica.arquivos.splice(index, 1);
    },

    addSubtema: function () {
      this.form.descricaoTecnica.subtemasSelecionados.push({
        subtemaId: null,
        descricaoPersonalizada: null,
      });
    },

    removeSubtema: function (subtema) {
      let index =
        this.form.descricaoTecnica.subtemasSelecionados.indexOf(subtema);
      this.form.descricaoTecnica.subtemasSelecionados.splice(index, 1);
    },

    buscarTemas: function () {
      this.$store.dispatch(START_LOADING);
      InfosService.buscarTemas()
        .then((response) => {
          this.options.temas = response.data.data
            .map((el) => {
              return { value: el.id, text: el.nome };
            })
            .sort((a, b) => {
              if (b.text == "Outros") return -1;
              if (a.text < b.text) {
                return -1;
              }
              if (a.text > b.text) {
                return 1;
              }
              return 0;
            });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    buscarSubtemas: function () {
      this.$store.dispatch(START_LOADING);
      InfosService.buscarSubtemas()
        .then((response) => {
          this.options.subtemas = response.data.data
            .map((el) => {
              return { value: el.id, text: el.nome };
            })
            .sort((a, b) => {
              if (a.text < b.text) {
                return -1;
              }
              if (a.text > b.text) {
                return 1;
              }
              return 0;
            });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    salvar: function (e) {
      e.preventDefault();
      this.confirmar("Deseja salvar proposta?").then((confirmado) => {
        if (!confirmado) return;

        if (this.validateState("form-") == false) return;

        if (this.empresaSelecionada == null) {
          this.alertaAviso("Selecione uma empresa");
          return;
        }

        this.$store.dispatch(START_LOADING);

        let form = cloneDeep(this.form);
        if (!form.descricaoTecnica.id)
          form.empresaId = this.empresaSelecionada.id;

        form.descricaoTecnica.valorEstimado =
          form.descricaoTecnica.valorEstimado
            .replace("R$", "")
            .replace(/\./g, "")
            .replace(",", ".")
            .trim();

        form.descricaoTecnica.propostaCooperadaId = this.propostaId;
        form.descricaoTecnica.propostaProponenteId = this.propostaId;

        PropostaService.salvarDescricaoTecnica(form)
          .then(() => {
            this.alertaSucesso("Proposta salva com sucesso!").then(() => {
              if (this.form.descricaoTecnica.id) {
                this.$emit("update");
              } else {
                this.$router.push({ name: "proposta-todos-lista" });
              }
            });
            this.buscarProposta();
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else this.alertaErro("Erro ao salvar proposta");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    excluir: function () {
      this.confirmar("Deseja excluir proposta?").then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);

        PropostaService.deletarProposta(this.form.descricaoTecnica.id)
          .then(() => {
            this.$store.dispatch("app/fetchUserData");

            this.alertaSucesso("Proposta excluida com sucesso!").then(() => {
              this.$router.push({ name: "proposta-lista" });
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else this.alertaErro("Erro ao salvar");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    buscarProposta: function () {
      this.$store.dispatch(START_LOADING);
      PropostaService.buscarProposta(this.propostaId)
        .then((response) => {
          let proposta = {};
          if (this.ehExecutora) {
            proposta = response.data.data;
          } else {
            proposta = response.data.data.proposta;
          }

          this.form.descricaoTecnica = proposta.descricaoTecnica;

          if (proposta.descricaoTecnica.temaSelecionado.tema)
            this.form.descricaoTecnica.temaSelecionado = {
              temaId: proposta.descricaoTecnica.temaSelecionado.tema.id,
              descricaoPersonalizada:
                proposta.descricaoTecnica.temaSelecionado
                  .descricaoPersonalizada,
            };

          if (this.form.descricaoTecnica.subtemasSelecionados.length) {
            if (this.form.descricaoTecnica.subtemasSelecionados[0].subtema)
              this.form.descricaoTecnica.subtemasSelecionados =
                proposta.descricaoTecnica.subtemasSelecionados.map((el) => {
                  return {
                    subtemaId: el.subtema.id,
                    descricaoPersonalizada: el.descricaoPersonalizada,
                  };
                });
          }

          this.form.descricaoTecnica.valorEstimado = helpers.formatarValor(
            proposta.descricaoTecnica.valorEstimado
          );
          this.form.descricaoTecnica.propostaId = this.propostaId;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    montar() {
      this.buscarTemas();
      this.buscarSubtemas();
      this.buscarProposta();
    },
  },
  mounted() {
    this.buscarTemas();
    this.buscarSubtemas();
  },
  computed: {
    empresaSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },
    TelaProponente() {
      return this.$route.name == "proposta-proponente-detalhamento";
    },
    TelaProponenteCooperada() {
      return this.$route.name == "proposta-proponente-cooperada-detalhamento";
    },
    ehExecutora: function () {
      return this.$route.name == "proposta-executora-detalhamento";
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"];
    },
    trlOptions() {
      const niveisPermitidos =
        TRL_POR_FASE_INOVACAO[this.form.descricaoTecnica.faseDeInovacao];
      if (!niveisPermitidos) return this.options.trls;
      return this.options.trls.filter((trl) =>
        niveisPermitidos.includes(trl.value)
      );
    },
  },
  watch: {
    "form.descricaoTecnica.faseDeInovacao"(novaFase, faseAnterior) {
      if (!faseAnterior) return;
      const trlAtual = this.form.descricaoTecnica.trl;
      const aindaValido = this.trlOptions.some((trl) => trl.value === trlAtual);
      if (!aindaValido) this.form.descricaoTecnica.trl = null;
    },
  },
};
</script>
<style>
.lista-arquivos {
  border: 1px solid #e5e5e5;
  background: #f9f9f9;
}
.lista-arquivos__no_top {
  border-top: none;
}
.lista-arquivos__left {
  border-left: 1px solid #e5e5e5;
}
</style>